// Minimal CSV exporter (client-side). Excel-friendly: UTF-8 BOM + CRLF line endings.
//
// Usage:
//   exportCSV("sponsors.csv", rows, [
//     { label: "Brand", accessor: (r) => r.brand_name },
//     { label: "Rack ₹ Cr", accessor: (r) => r.value_cr * r.slots_taken },
//   ]);

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (s.includes(",") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function exportCSV(filename, rows, columns) {
  const header = columns.map((c) => escapeCell(c.label)).join(",");
  const body = rows.map((r) => columns.map((c) => escapeCell(c.accessor(r))).join(",")).join("\r\n");
  const csv = "\uFEFF" + header + "\r\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
